import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const EmbedReferenceContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 600px;
  overflow: hidden;
`;

export const PlaceholderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const PreviewContainer = styled.div`
  margin-left: ${token('space.100')};
  margin-right: ${token('space.100')};
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: ${token('space.100')};
`;

export const PreviewPlaceholderHeaderText = styled.p`
  font: ${token('font.heading.medium')};
  text-align: center;
  width: 400px;
`;

export const ValueContainer = styled.div`
  margin-top: ${token('space.400')};
  margin-left: ${token('space.200')};
`;

export const PreviewPlaceholderText = styled.p`
  font: ${token('font.body')};
  width: 240px;
  text-align: center;
`;
